import classNames from 'classnames';
import React from 'react';
import { ScrollToTop } from '../../components/scroll_to_top/scroll_to_top';
import { SEO } from '../../components/seo/seo';
import base from '../../styles/base.less';
import styles from '../../styles/static_pages.less';

const PrivacyPage = () => {
  return (
    <ScrollToTop>
      <section className={classNames(base.contentWrapper, styles.staticWrapper)}>
        <SEO title="Privacy" />

        <h1>Privacy Policy</h1>
        <p>
          Welcome to OmniaFishing.com together with any other websites or applications branded as
          Omnia ("Website"), our other applications and tools, and any related services
          (collectively the "Services"), operated by Omnia Fishing, Inc. ("Omnia," "we," "our,"
          "us") a Delaware Corporation. We respect your privacy rights and are committed to
          protecting them. Our Privacy Policy describes the information we collect and how we use
          it. It is intended to describe to you how and what data we collect when you use the
          Website or otherwise, and how and why we use your personal data. It also describes options
          we provide for you to access, update or otherwise take control of your personal data that
          we process.
        </p>
        <p>
          <strong>
            <em>Effective as of and last updated on May 19, 2021</em>
          </strong>
        </p>
        <p>
          This Privacy Policy applies, without limitation, to any individual or entity that (i) uses
          the Website, (ii) creates an Account (as defined in our Terms of Use), or (iii) otherwise
          provides any personal, company, financial or other information to us.
        </p>
        <p>
          Your continued use of this site constitutes your continued acceptance of this Privacy
          Policy that may change from time to time.By using or accessing the Services, you confirm
          that you have received this and that you agree to the use of your information as explained
          in this Policy. If you do not agree, please do not use the Services.&nbsp;
        </p>
        <p>
          <strong>
            IF YOU DO NOT AGREE TO THIS PRIVACY POLICY, OR TO ANY CHANGES WE MAY SUBSEQUENTLY MAKE
            TO THIS PRIVACY POLICY, YOU MUST IMMEDIATELY STOP USING THE WEBSITE OR OTHERWISE
            PROVIDING ANY INFORMATION TO US.
          </strong>
        </p>
        <p>
          The Website may contain links to other websites. This Privacy Policy does not apply to
          information collected on, by, or through any third-party websites. We are not responsible
          for the privacy practices of such third parties or the content of their websites. Such
          third parties may have their own privacy policies and you should review those privacy
          policies to determine their privacy practices.
        </p>
        <p>
          <strong>Personal Data Collected</strong>
        </p>
        <ul>
          <li>
            Your name, addresses, telephone numbers, e-mail addresses, date of birth, username,
            password and other personally identifiable information;
          </li>
          <li>
            Certain financial or demographic profile information to be used in the aggregate, such
            as your age, gender, hobbies, interests, zip/postal code or country;
          </li>
          <li>
            Service provider name and the date, time and content of any messages sent from you to
            us;
          </li>
          <li>
            IP address and other technical information collected from the servers utilized by you or
            your vendors, such as information and data that is automatically collected upon visiting
            the Website;
          </li>
          <li>
            Credit/debit card and other billing information, including cardholder transaction data,
            card numbers, expiration dates, billing addresses and CVV codes;
          </li>
          <li>
            Information provided on any application or authorization, such as your location, your
            handset type, your UDID and any other information you or your mobile device provides to
            us;
          </li>
          <li>Information regarding uses of the services; and</li>
          <li>Other information provided to us in any way, shape or form.</li>
        </ul>
        <p>
          <strong>How Information is Collected</strong>
        </p>
        <p>
          We may collect information in one or more of the following ways leading up to or during
          our course of business with you:
        </p>
        <ul>
          <li>Create an account on one of our websites;</li>
          <li>Participate in one of our promotional offers, contests or surveys;</li>
          <li>
            Make an online purchase or other transaction or request a service where we collect
            information;
          </li>
          <li>
            When you respond to a product recommendation and make a purchase or reject the
            recommendation and suggest changes to the recommendation service when you provide us
            with information regarding current or planned fishing equipment or tackle purchases or
            use our services regarding, related to, or otherwise use to facilitate current or
            planned fishing equipment or tackle purchases;
          </li>
          <li>
            Post a review or comment on one of our social media pages, or post a rating, review or
            other user-generated content on one of our websites;
          </li>
          <li>
            Through the completion of electronic forms found on the Website or on a third
            party-hosted website, whether via computer or mobile device;
          </li>
          <li>Contact us to request service or provide comments or suggestions;</li>
          <li>Through the completion of paper forms provided to us;</li>
          <li>
            Through SMS messages sent via cell phone, or through e-mail and other communications;
          </li>
          <li>Through telephone calls made to us, or vice versa;</li>
          <li>Through surveys;</li>
          <li>
            Through referring websites or third parties, including social media sites such as
            Facebook, Twitter, Tumblr, Instagram, Pinterest, YouTube, Google+ and others;
          </li>
          <li>Through the maintenance and analysis of Website server logs; and</li>
          <li>
            Via &ldquo;cookies,&rdquo; Website server log analysis and other similar technological
            means.
          </li>
        </ul>
        <p>
          Certain portions of the Website may require that you register for an Account before being
          able to access them. On those portions of the Website that require registration, we may
          collect information to create your account, as well as to determine specific content,
          products and services that may be of particular interest to you. By collecting and
          maintaining accurate information, we learn more about your interests and needs and are
          better able to provide you with such content and with offers for such products and
          services.
        </p>
        <p>
          <strong>Use of Web Technologies for Data Collection</strong>
        </p>
        <p>
          We use cookies. A cookie is a small text file that is stored on a user&rsquo;s computer
          for record keeping purposes. We may link the information we store in cookies to personally
          identifiable information that you submit while on the Website. We use both session ID
          cookies and persistent cookies.A session ID cookie expires when a browser is closed.A
          persistent cookie remains on your hard drive for an extended period of time.Persistent
          cookies also enable us to track and target the interests of our users to enhance the
          experience on the Website. You can remove the persistent cookies by following the
          directions provided in your internet browser&rsquo;s &ldquo;help&rdquo; file. If you
          reject cookies, you may still use the Website but your ability to use some areas of the
          Website may be limited.
        </p>
        <p>
          With the help of third-party services, we use a process called pixel tracking to
          anonymously track online use patterns.Tracking pixels are graphic with dimensions of a
          single pixel that is loaded when a user visits a website or opens an email and is used to
          track certain user activities. With a tracking pixel, advertisers can acquire data for
          online marketing, web analysis or email marketing.&nbsp;
        </p>
        <p>
          Like most websites we use Google Analytics to help us gather meaningful insights on our
          traffic and, among other things, monitor marketing campaign performance. Although Google
          Analytics plants a permanent cookie on your web browser to identify you as a unique user
          the next time you visit the Website, the cookie cannot be used by anyone other than
          Google. Google's ability to use and share information collected by Google Analytics about
          your visits to the Website is restricted by the{' '}
          <a href="https://www.google.com/analytics/terms/us.html">Google Analytics Terms of Use</a>{' '}
          and the <a href="https://www.google.com/policies/privacy/">Google Privacy Policy</a>.
          Google Analytics collects only the IP address assigned to you on the date you visit the
          Website, rather than your name or other identifying information.You can prevent Google
          Analytics from recognizing you on return visits to the Website by disabling cookies on
          your browser which may also limit your ability to use all functions of the Website.
        </p>
        <p>
          As is true of most websites, we gather information automatically and store it in log
          files. This information includes internet protocol (IP) addresses, browser type, internet
          service provider (ISP), referring/exit pages, operating system, date/time stamp and
          clickstream data. We use this information, which does not identify individual users, to
          analyze trends, to administer the Website, to track the movements of users around the
          Website and to gather demographic information about our userbase.
        </p>
        <p>
          <strong>No Information Collected from Children</strong>
        </p>
        <p>
          The content and services provided by us or our affiliates, sponsors and advertisers are
          not intended for children under the age of 13. If you are under the age of 18 or otherwise
          not of legal age to form a binding contract in your place of residence, you must have your
          parent or legal guardian&rsquo;s permission to use the Website and all actions on the site
          must be done with your parent or guardian present at all times. No information is
          knowingly collected or retained from children under the age of 13, nor is any such
          information knowingly used for any marketing or promotional purposes whatsoever, either
          inside or outside the Website. No part of the Website is designed to attract anyone under
          the age of 13.
        </p>
        <p>
          Children are not eligible to use any services provided by us and we ask that children
          under the age of 13 not submit any personal information to us or visit the Website.
        </p>
        <p>
          <strong>Use of Personal Information</strong>
        </p>
        <p>
          Your privacy is important to us. Any data collected and/or stored by us is used to provide
          the Services and improve our Services, develop new products and Services either under the
          name Omnia or in concert with a third party, fulfill your orders, make better
          recommendations on products and/or services, conduct statistical analysis, provide
          information to research partners, analyze your use and personalize the Services. We may
          also use your information for marketing purposes from time to time but only in a way that
          we think will be useful to you as an angler.
        </p>
        <p>
          When we use third parties to assist us in collecting and/or processing your personal
          information, we typically request that they comply with this Privacy Policy and any other
          appropriate confidentiality and security measures. However, we make no representation or
          warranty that such third parties will comply with any such request.
        </p>
        <p>Some examples of how we use your personal information for marketing purposes include:</p>
        <ul>
          <li>To register and service your account;</li>
          <li>To send you information about our products, services, and promotions;</li>
          <li>
            To fulfill your shopping and other requests for products and services and communicate
            with you about those requests;
          </li>
          <li>To administer contests, sweepstakes, promotions, and surveys;</li>
          <li>To help us improve your experience on our Website;</li>
          <li>To protect the security and integrity of our Websites and our business;</li>
          <li>To respond to reviews, comments, or other feedback you provide to us;</li>
          <li>
            To improve our recommendation engine (recommendation algorithm) to suggest products
            based on, among other things, user profile settings and geographic preferences;
          </li>
          <li>To help us personalize our service offerings, Websites, and advertising; And</li>
          <li>To provide customer service and alert you to product information.</li>
        </ul>
        <p>
          We also combine personal and non-personal information, collected online and offline,
          including information from third party sources.&nbsp;
        </p>
        <p>
          We may add your information to our databases to contact you through future e-mails, postal
          mailings and SMS text-messaging regarding site updates, upcoming events, new products and
          services and/or the status of orders placed online. We currently use geolocation for
          purposes of tracking your location when you use the Website in order to better target
          product and service offerings and other information to you.
        </p>
        <p>
          During promotional events in which you provide your email address, your email address may
          be provided to another company that co-sponsors that promotion. In these cases, the terms
          of the promotion will explain how your email address is being used and whether it will be
          shared.
        </p>
        <p>
          <strong>Responding to an Investigative Body </strong>
        </p>
        <p>
          We may share your personal information in special circumstances, which include situations
          when sharing is required by law, or we believe sharing will help to protect the safety,
          property, or rights of Us, our customers, our associates, or other persons.
        </p>
        <p>Examples include:</p>
        <ul>
          <li>Protecting the health or safety of our customers;</li>
          <li>Identifying and addressing fraud or financial risk;</li>
          <li>
            Providing personal information from cameras to law enforcement at their written request;
          </li>
          <li>
            Responding to discovery in a legal proceeding or to a search warrant or other valid
            legal inquiry; and
          </li>
          <li>Addressing crimes committed on our property or through our websites.</li>
        </ul>
        <p>
          <strong>International Users</strong>
        </p>
        <p>
          Our business, servers and offices headquartered in the United States.Please be aware that
          information you provide to us or that we obtain as a result of your use of the Website, an
          Account, or any services provided by us may be processed and transferred to, and be
          subject to the laws of, the United States.
        </p>
        <p>
          The privacy and data protection laws in the United States may not be equivalent to similar
          laws in your country of residence. By using the Website or an Account, or by providing us
          with your information, you consent to the collection, transfer, storage and processing of
          information to and within the United States. If our cookies or other software detects IP
          addresses located in a country outside the United States, we reserve the right to deny
          access to any and all of our services.
        </p>
        <p>
          <strong>Data Retention</strong>
        </p>
        <p>
          We store profile data like name, username, password, email address, telephone number,
          address and gender and the content created by you such as posts, photos, and videos, as
          long as it is necessary for the provision of our services to you. If you wish us to
          discontinue storing this data, please contact us at{' '}
          <a href="mailto:support@omniafishing.com">support@omniafishing.com</a>
        </p>
        <p>
          <strong>Account Deactivation</strong>
        </p>
        <p>
          If you have an account with us and object to our processing of your personal data or you
          want us to deactivate your account, you can ask us to deactivate it by contacting us at{' '}
          <a href="mailto:support@omniafishing.com">support@omniafishing.com</a>. We may ask you for
          other information before we are able to deactivate your account.
        </p>
        <p>
          <strong>Business transfers</strong>
        </p>
        <p>
          In the event that all or a part of our business is merged, sold or reorganized, personal
          information about you could be shared with the successor business. We will use reasonable
          measures to help ensure that any successor treats your information in accordance with this
          Privacy Policy.
        </p>
        <p>
          <strong>Marketing preferences</strong>
        </p>
        <p>
          We use an opt-out standard for email or for most communications, such as postal mail, but
          will employ an opt-in standard for third party communications. If you want to be removed
          from our marketing list and do not want us to send you e-mail, postal mail or other
          messages about our products and services, you can opt out in any email that you receive.
        </p>
        <p>
          Please know that, even if you opted out of receiving marketing communications from us, we
          may still need to contact you for transactional or informational purposes such as customer
          service details, product information updates, service or reminder notices, customer
          surveys, or recalls. We may also need to contact you with questions or information
          regarding your order.
        </p>
        <p>
          California Civil Code permits California residents to request certain information
          regarding our disclosure of such residents&rsquo; personal information to third parties
          for such third parties&rsquo; direct marketing purposes. To make such a request, please
          e-mail us at <a href="mailto:support@OmniaFishing.com">support@OmniaFishing.com</a>.
        </p>
        <p>
          <strong>Recommended Products (Omnia Engine)</strong>
        </p>
        <p>
          The Omnia fishing experience relies on our ability to offer a hyper-personalized
          experience on our sites by showing the products we think best fit your needs.We may also
          provide you with advertisements in this recommendation process that we feel best fit your
          interests.Many of these suggestions are based on the water bodies that you&rsquo;ve
          indicated as a preference if your account.However, from time to time we make suggestions
          to you and to others based on inputs during the shopping experience that our user base,
          including you, make as part of your use of the Website including but not limited to the
          checkout process. We will do our best to indicate to you when suggestions are based on
          your preferences, the preferences of others, and advertisements from our partners.
        </p>
        <p>
          <strong>Location Settings</strong>
        </p>
        <p>
          Some of our services use your device&rsquo;s location information. You can adjust the
          settings of your mobile device at any time to control whether your device communicates
          this location information. See your device instructions to learn more about these
          settings. In addition, as explained above, we may offer you controls on our use of your
          mobile location information.
        </p>
        <p>
          <strong>Contact us</strong>
        </p>
        <p>
          If you have questions about this Privacy Policy, you can contact us at the following
          address:
        </p>
        <p>Omnia Fishing, LLC</p>
        <p>
          6325 Sandburg Road <br />
          Suite 100
          <br />
          Golden Valley, MN 55427
        </p>
        <p>Or by email: support@omniafishing.com</p>
        <p>
          <strong>Updates to this Privacy Policy</strong>
        </p>
        <p>Any changes made to this will be shown at the top of this page as the Effective Date.</p>
        <p>
          REMINDER: Your continued use of this site constitutes your continued acceptance of this
          Policy.By using or accessing the Services, you confirm that you have received this Privacy
          Policy and that you agree to the use of your information as explained in this Privacy
          Policy. If you do not agree, please do not use the Services.
        </p>
      </section>
    </ScrollToTop>
  );
};
export default PrivacyPage;
